module.exports = __webpack_public_path__ + "static/abstract-vector-dac0dd5d0ee15ba3535da0850c482cff.png";